import React, { useCallback, useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Woman from "../../assets/images/woman.png";
import "./usermanagetable.scss";
import Avatar from "@mui/material/Avatar";
import { connect } from "react-redux";

import {
  showDetail,
  userDetail,
  getUserDetails,
  getAllAssessmentUserList,
  getAssessmentUserDetails,
  exportUserData,
} from "../../redux/action/user";
import BaseTable, { buildQuery } from "../BaseTable/BaseTable";
import { Tooltip } from "@mui/material";
import { useLocation } from "react-router";
import ScreenLoader from "../ScreenLoader";
import { toast } from "react-toastify";

const UserListTable = (props) => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState(filterData);
  const location = useLocation();
  const list = props.userAssessmentList || {};
  const [paginationParams, setPaginationParams] = useState({
    currentPage: 1,
    limit: 10,
    total: 1,
    totalRecords: 0,
  });

  const fetchUsers = useCallback(() => {
    const query = buildQuery(filters, paginationParams.currentPage, paginationParams.limit);
    props.getAllAssessmentUserList(query);
  }, [filters, paginationParams.currentPage, paginationParams.limit, props.getAllAssessmentUserList]);


  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);


  useEffect(() => {
    if (props.userAssessmentList?.pagination) {
      setPaginationParams((prev) => {
        if (
          prev.currentPage === props.userAssessmentList.pagination.currentPage &&
          prev.limit === props.userAssessmentList.pagination.pageSize &&
          prev.total === props.userAssessmentList.pagination.totalPages &&
          prev.totalRecords === props.userAssessmentList.pagination.totalUsers
        ) {
          return prev;
        }

        return {
          currentPage: props.userAssessmentList.pagination.currentPage || 1,
          limit: props.userAssessmentList.pagination.pageSize || 10,
          total: props.userAssessmentList.pagination.totalPages || 1,
          totalRecords: props.userAssessmentList.pagination.totalUsers || 0,
        };
      });
    }
  }, [props.userAssessmentList]);




  useEffect(() => {
    const newArr = filterData.map(el => ({
      ...el,
      value: ''
    }));
    setFilters(newArr);
  }, [location.pathname]);


  const handleFilterClick = (updatedFilters) => {
    setPaginationParams((prev) => ({
      ...prev,
      currentPage: 1,
    }));
    setFilters(updatedFilters);
  };


  const handleExportData = async () => {
    setLoading(true);
    try {
      const res = await exportUserData(
        buildQuery(filters, paginationParams.currentPage, paginationParams.limit)
      );

      const blob = new Blob([res.data], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "user_report.csv";
      link.click();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      let errorMessage = "Something went wrong during export.";

      // Check if it's a blob error response
      if (
        error.response &&
        error.response.data instanceof Blob &&
        error.response.data.type === "application/json"
      ) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          errorMessage = json?.message || errorMessage;
        } catch (parseError) {
          console.error("Failed to parse blob error:", parseError);
        }
      }

      console.error("Download error:", error);
      toast(errorMessage); // Show the parsed or default message
    } finally {
      setLoading(false);
    }
  };


  const UserDetails = (userid, toggle, orgUserId) => {
    localStorage.setItem("userAssessmentId", userid);
    // props.getUserDetails(orgUserId);
    // props.userDetail(userid);
    props.showDetail(toggle);
    // props.getAssessmentUserDetails(userid);
  };

  useEffect(() => {
    localStorage.setItem("userRole", props?.role);
  }, [props?.role]);

  const headers = [
    { label: "Name", align: "center" },
    { label: "Email", align: "center" },
    // { label: "Mobile Number", align: "center" },
    { label: "Total Assessments", align: "center" },
    { label: "Current Plan/Subscription", align: "center" },
    { label: "Member Type", align: "center" },
    { label: "Status", align: "center" },
  ];

  /** Merge CurrentPlan + CurrentSubscription so the same programSubscriptionId is one row (name + dates). */
  const getDisplaySubscriptionList = (row) => {
    const fromPlan = row?.CurrentPlan || [];
    const sub = row?.CurrentSubscription;
    const hasSubId =
      sub?.programSubscriptionId != null && sub.programSubscriptionId !== "";
    const items = [...fromPlan, ...(hasSubId ? [sub] : [])].filter(Boolean);

    const byId = new Map();
    const withoutId = [];

    for (const ele of items) {
      const id = ele?.programSubscriptionId;
      if (id == null || id === "") {
        withoutId.push(ele);
        continue;
      }
      const prev = byId.get(id);
      if (!prev) {
        byId.set(id, { ...ele });
        continue;
      }
      byId.set(id, {
        ...prev,
        ...ele,
        name: prev?.name || ele?.name,
        programName: prev?.programName || ele?.programName,
        purchasedDate:
          ele?.purchasedDate ||
          prev?.purchasedDate ||
          ele?.createdAt ||
          prev?.createdAt,
        expirationDate:
          ele?.expirationDate ||
          prev?.expirationDate ||
          ele?.expirationTime ||
          prev?.expirationTime,
      });
    }
    return [...byId.values(), ...withoutId];
  };

  const renderRows = () => {
    return (
      list &&
      list.userList &&
      list.userList?.map((row, index) => {
        return (
          <TableRow
            key={index}

            className="table-row"
            sx={{
              "&:last-child td, &:last-child th": { border: 0 },
              "& th": {
                color: "#fff",
                borderBottom: "1px solid #273334",
              },
              "& td": {
                borderBottom: "1px solid #273334",
              },
            }}
          >
            <TableCell
              component="th"
              scope="row"
              align="left"
              className="text-white"
              onClick={() => UserDetails(row?.UserID, true, 0)}
            >
              <div className="d-flex overEffect align-items-center">
                <Avatar className="mx-3" alt="Travis Howard" src={Woman} />
                <div>
                  <span className="nameText">
                    {row?.Name ? row?.Name : "Robot"}{" "}
                  </span>
                </div>
              </div>
            </TableCell>

            <TableCell align="center" className="text-white qualification">
              {row?.Email ? row?.Email : "Therapist"}
            </TableCell>
            {/* <TableCell align="center" className="expirence">
              {row?.MobileNumber ? row?.MobileNumber : 0}
            </TableCell> */}
            <TableCell align="center" className="text-white totalContent">
              {row?.TotalAssessments ? row?.TotalAssessments : 0}
            </TableCell>
            <TableCell align="center" className="text-white">
              {(() => {
                const displaySubs = getDisplaySubscriptionList(row);
                const formatDate = (date) => {
                  const parsedDate = new Date(date);
                  return isNaN(parsedDate)
                    ? ""
                    : parsedDate.toLocaleDateString("en-GB");
                };

                if (!displaySubs.length) {
                  return <span>-</span>;
                }

                return displaySubs.map((ele, idx, arr) => {
                  const startRaw =
                    ele?.purchasedDate ??
                    ele?.createdAt;
                  const endRaw =
                    ele?.expirationDate ??
                    ele?.expirationTime;
                  const formattedStartDate = startRaw
                    ? formatDate(startRaw)
                    : "";
                  const formattedEndDate = endRaw
                    ? formatDate(endRaw)
                    : "";
                  const displayName =
                    ele?.name ||
                    ele?.programName ||
                    ele?.js_programSubscription?.name ||
                    "";
                  const rowKey =
                    ele?.programSubscriptionId != null
                      ? String(ele.programSubscriptionId)
                      : `sub-${idx}`;

                  return (
                    <span key={rowKey}>
                      <Tooltip
                        title={`Start Date: ${formattedStartDate}, End Date: ${formattedEndDate}`}
                        arrow
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          {displayName}
                          {idx < arr.length - 1 ? ", " : ""}
                        </span>
                      </Tooltip>
                    </span>
                  );
                });
              })()}
            </TableCell>
            <TableCell align="center" className="text-white">
              <p
                // className={
                //   row?.isPaid == 1 ? "user-active" : "user-inactive"
                // }
                className={
                  row?.isPaid === 1
                    ? "user-active"
                    : row?.isPaid === 0
                      ? "user-inactive"
                      : row?.isPaid === 2
                        ? "user-cancelled"
                        : ""
                }


              >
                <p className="user-active-on"> </p>
                {row?.isPaid === 1
                  ? "Paid"
                  : row?.isPaid === 0
                    ? "Free"
                    : row?.isPaid === 2
                      ? "Cancelled"
                      : ""}
              </p>
            </TableCell>
            <TableCell align="center" className="text-white">
              {row?.Status === "A" ? "Active" : "Deactivated"}
            </TableCell>
          </TableRow>
        );
      })
    );
  };

  return (
    <div>
      {loading && <ScreenLoader />}
      <BaseTable
        headers={headers}
        rows={list?.userList || []}
        renderRows={renderRows}
        // fetchData={props.getAllAssessmentUserList}
        isLoading={props.userAssessmentLoading}
        showPagination={paginationParams.totalRecords > 0}
        paginationParams={paginationParams}
        setPaginationParams={setPaginationParams}
        currentPage={paginationParams.currentPage}
        limit={paginationParams.limit}
        handleFilterClick={handleFilterClick}
        handleExportData={handleExportData}
        filters={filters}
        isFilter={true}
        height={"500px"}
      />
    </div>
  );
};

UserListTable.propTypes = {};
UserListTable.defaultProps = {};

const actionCreators = {
  showDetail,
  getAllAssessmentUserList,
  userDetail,
  getUserDetails,
  getAssessmentUserDetails,
};

export default connect(
  ({ user }) => ({
    allUsers: user.allUser,
    allUserLoading: user.allUserLoading,
    userAssessmentLoading: user.userAssessmentLoading,
    userAssessmentList: user.userAssessmentList,
  }),
  actionCreators
)(UserListTable);

const filterData = [
  { id: 1, label: "Name", value: "", type: "input", name: "name" },
  { id: 2, label: "Email", value: "", type: "input", name: "email" },
  {
    id: 3,
    label: "Status",
    name: "status",
    value: "",
    type: "multi-select",
    dropArr: [
      {
        value: "Active",
        label: "Active",
      },
      {
        value: "Deactive",
        label: "Deactive",
      },
    ],
  },
  {
    id: 4,
    label: "Member Type",
    name: "isPaid",
    value: "",
    type: "multi-select",
    dropArr: [
      {
        value: "free",
        label: "Free",
      },
      {
        value: "paid",
        label: "Paid",
      },
      {
        value: "cancel",
        label: "Cancelled",
      },
    ],
  },
  { id: 5, name: "totalAssessments", label: "Total Assessments", value: "", type: "input-number" },
  { id: 6, name: "date", label: "Date", value: "", type: "date" },
  { id: 7, label: "Coupon Code", value: "", type: "input", name: "couponCode" },
];
